module.exports = __webpack_public_path__ + "static/media/buzon-rojo-evidencia.de88482e.png";